/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useEffect, useRef } from 'react'
import { useServiceContext } from '../../../root'
import { useModal } from '../../../contexts/ModalContext'
import DOMPurify from 'dompurify'

interface ActivityESignatureCommentModalProps {
  esignatureComment: string
}

export const ActivityESignatureCommentModal: React.FC<ActivityESignatureCommentModalProps> = ({
  esignatureComment
}) => {
  const {
    service: {
      filter: { translate }
    }
  } = useServiceContext()
  const { hideModal } = useModal()
  const modalRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      hideModal()
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      hideModal()
    }
  }

  // Sanitize HTML to prevent XSS
  const sanitizedComment = DOMPurify.sanitize(esignatureComment || '')

  return (
    <div className="theme-sandman">
      {/* Modal Backdrop */}
      <div className="modal-backdrop fade in" onClick={handleBackdropClick} aria-hidden="true" />

      {/* Modal Dialog */}
      <div
        ref={modalRef}
        className="modal fade in"
        id="modal-add-file"
        style={{ display: 'block' }}
        tabIndex={-1}
        role="dialog"
        onClick={handleBackdropClick}
        onKeyDown={handleKeyDown}
      >
        <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">{translate('REPORTS_CAPTURED_ESIG_DISCLOSURE')}</h3>
              <i className="close-modal" onClick={() => hideModal()} />
            </div>

            <div className="modal-body">
              <p className="word-break" dangerouslySetInnerHTML={{ __html: sanitizedComment }} />
            </div>

            <div className="modal-footer">
              <button className="btn btn-primary" type="button" onClick={() => hideModal()}>
                {translate('OK')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ActivityESignatureCommentModal
